<div class="min-h-screen bg-white px-4 py-6 md:px-8" *ngIf="conclave_view">
  <div *ngIf="isLoading" class="py-10 text-center text-slate-600">
    Loading conclave details...
  </div>
  <div
    *ngIf="!isLoading && errorMessage"
    class="py-10 text-center text-red-600"
  >
    {{ errorMessage }}
  </div>
 
  <div *ngIf="!isLoading && !errorMessage">
    <div class="mx-auto max-w-7xl">
      <!-- Cover Image -->
      <div class="overflow-hidden rounded-xl shadow-sm">
        <img
          [src]="coverImageUrl"
          alt="Conclave Cover"
          class="h-[260px] w-full object-cover md:h-[320px]"
        />
      </div>
 
      <!-- Header -->
      <div
  class="mt-6 flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between"
>
  <!-- Left -->
  <div class="flex items-start gap-5">
    <!-- Date Card -->
    <div
      class="overflow-hidden rounded-xl border border-slate-300 bg-white shadow-sm"
    >
      <div
        class="bg-[#073B4C] px-5 py-2 text-center text-sm font-medium text-white"
      >
        {{ formatMonthShort(conclave?.start_date) || '—' }}
      </div>
 
      <div
        class="flex h-[55px] w-[55px] items-center justify-center text-2xl font-semibold text-[#073B4C]"
      >
        {{ formatDayNumber(conclave?.start_date) || '—' }}
      </div>
    </div>
 
    <!-- Title -->
    <div>
      <div class="flex flex-wrap items-center gap-2">
        <h1
          class="text-3xl font-semibold tracking-tight text-[#073B4C] md:text-2xl"
        >
          {{ conclave?.title || 'Conclave' }}
        </h1>
 
        <!-- Badge -->
        <span
          class="rounded-full bg-lime-500 px-4 py-1 text-sm font-medium text-white shadow-sm"
        >
          {{ badgeText }}
        </span>
      </div>
 
      <p class="mt-3 text-sm text-slate-600">
        Organised by : Teacher Factory
      </p>
    </div>
  </div>
 
  <!-- Right -->
  <button
    *ngIf="isUpcomingConclave && conclave_share"
    type="button"
    class="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white mx-3 py-2 px-3 gap-1 text-slate-600 shadow-sm hover:bg-slate-50"
  >
    <i class="fa-solid fa-share-nodes text-base"></i>
    Share
  </button>
</div>
 
      <!-- Rankers Section -->
      <div class="py-4">
        <div class="rounded-2xl border border-slate-200 bg-white p-5 mb-4">
          <h2 class="text-sm font-semibold text-[#073B4C] mb-4">Rankers</h2>
          <div class="flex gap-3 overflow-x-auto pb-1 scrollbar-hide">
            <!-- Static placeholders kept as original UI -->
            <div class="flex-shrink-0 w-[110px] rounded-xl border border-slate-200 bg-white p-3 flex flex-col items-center gap-2">
              <div class="text-center">
                <div class="text-2xl font-semibold text-[#073B4C] leading-none">1</div>
                <div class="text-[11px] text-slate-400">Rank</div>
              </div>
              <img
                src="https://randomuser.me/api/portraits/men/32.jpg"
                alt="Anand Sharma"
                class="w-12 h-12 rounded-full object-cover"
              />
              <div class="text-center">
                <p class="text-[13px] font-medium text-slate-800">Anand Sharma</p>
                <p class="text-[12px] text-slate-500">9<sup>th</sup> (A)</p>
              </div>
            </div>
 
            <div class="flex-shrink-0 w-[110px] rounded-xl border border-slate-200 bg-white p-3 flex flex-col items-center gap-2">
              <div class="text-center">
                <div class="text-2xl font-semibold text-[#073B4C] leading-none">2</div>
                <div class="text-[11px] text-slate-400">Rank</div>
              </div>
              <img
                src="https://randomuser.me/api/portraits/women/44.jpg"
                alt="Anand Sharma"
                class="w-12 h-12 rounded-full object-cover"
              />
              <div class="text-center">
                <p class="text-[13px] font-medium text-slate-800">Anand Sharma</p>
                <p class="text-[12px] text-slate-500">9<sup>th</sup> (A)</p>
              </div>
            </div>
 
            <div class="flex-shrink-0 w-[110px] rounded-xl border border-slate-200 bg-white p-3 flex flex-col items-center gap-2">
              <div class="text-center">
                <div class="text-2xl font-semibold text-[#073B4C] leading-none">3</div>
                <div class="text-[11px] text-slate-400">Rank</div>
              </div>
              <img
                src="https://randomuser.me/api/portraits/women/55.jpg"
                alt="Anand Sharma"
                class="w-12 h-12 rounded-full object-cover"
              />
              <div class="text-center">
                <p class="text-[13px] font-medium text-slate-800">Anand Sharma</p>
                <p class="text-[12px] text-slate-500">9<sup>th</sup> (A)</p>
              </div>
            </div>
 
            <div class="flex-shrink-0 w-[110px] rounded-xl border border-slate-200 bg-white p-3 flex flex-col items-center gap-2">
              <div class="text-center">
                <div class="text-2xl font-semibold text-[#073B4C] leading-none">4</div>
                <div class="text-[11px] text-slate-400">Rank</div>
              </div>
              <img
                src="https://randomuser.me/api/portraits/men/45.jpg"
                alt="Anand Sharma"
                class="w-12 h-12 rounded-full object-cover"
              />
              <div class="text-center">
                <p class="text-[13px] font-medium text-slate-800">Anand Sharma</p>
                <p class="text-[12px] text-slate-500">9<sup>th</sup> (A)</p>
              </div>
            </div>
 
            <div class="flex-shrink-0 w-[110px] rounded-xl border border-slate-200 bg-white p-3 flex flex-col items-center gap-2">
              <div class="text-center">
                <div class="text-2xl font-semibold text-[#073B4C] leading-none">5</div>
                <div class="text-[11px] text-slate-400">Rank</div>
              </div>
              <img
                src="https://randomuser.me/api/portraits/women/33.jpg"
                alt="Anand Sharma"
                class="w-12 h-12 rounded-full object-cover"
              />
              <div class="text-center">
                <p class="text-[13px] font-medium text-slate-800">Anand Sharma</p>
                <p class="text-[12px] text-slate-500">9<sup>th</sup> (A)</p>
              </div>
            </div>
 
            <div class="flex-shrink-0 w-[110px] rounded-xl border border-slate-200 bg-white p-3 flex flex-col items-center gap-2">
              <div class="text-center">
                <div class="text-2xl font-semibold text-[#073B4C] leading-none">6</div>
                <div class="text-[11px] text-slate-400">Rank</div>
              </div>
              <img
                src="https://randomuser.me/api/portraits/women/66.jpg"
                alt="Anand Sharma"
                class="w-12 h-12 rounded-full object-cover"
              />
              <div class="text-center">
                <p class="text-[13px] font-medium text-slate-800">Anand Sharma</p>
                <p class="text-[12px] text-slate-500">9<sup>th</sup> (A)</p>
              </div>
            </div>
          </div>
        </div>
 
        <!-- Info Row -->
        <div
          class="grid grid-cols-3 divide-x divide-slate-200 rounded-2xl border border-slate-200 bg-white overflow-hidden"
        >
          <!-- Location -->
          <div class="flex flex-col gap-1 p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 text-slate-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 13 6 13s6-7.75 6-13c0-3.314-2.686-6-6-6zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
              />
            </svg>
            <p class="text-[13px] font-medium text-slate-500">Location</p>
            <p class="text-[14px] font-medium text-slate-800">
              {{ locationText || '—' }}
            </p>
          </div>
 
          <!-- Date and Time -->
          <div class="flex flex-col gap-1 p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 text-slate-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6v6l4 2m6-2a10 10 0 1 1-20 0 10 10 0 0 1 20 0z"
              />
            </svg>
            <p class="text-[13px] font-medium text-slate-500">Date and Time</p>
            <p class="text-[14px] font-medium text-slate-800">
              {{ formatDate(conclave?.start_date) || '—' }}
            </p>
            <p class="text-[12px] text-slate-500">
              {{ conclave?.start_time || '' }}{{ conclave?.start_time ? ' ' : '' }}to
              {{ conclave?.end_time || '' }}
            </p>
          </div>
 
          <!-- Registrations -->
          <div class="flex flex-col justify-center p-4">
            <p class="text-4xl font-semibold text-[#073B4C]">
              {{ conclave?.selected_groups?.length || 0 }}
            </p>
            <p class="text-[13px] text-slate-500 mt-1">No. of Registrations</p>
          </div>
        </div>
      </div>
 
      <!-- Main Content -->
      <div class="mt-2 grid gap-2 lg:grid-cols-12">
        <!-- Left Content -->
        <div class="lg:col-span-8">
          <!-- About -->
          <div class="rounded-3xl bg-white p-4">
            <h2 class="text-md font-semibold text-[#073B4C]">About Conclave</h2>
            <p class="mt-2 leading-6 text-slate-600">
              {{ conclave?.description || '—' }}
            </p>
          </div>
 
          <div class="rounded-3xl bg-white p-4">
            <h2 class="text-md font-semibold text-[#073B4C]">Registration Link</h2>
            <p class="mt-2 leading-4 text-slate-600">
              {{ conclave?.registerion_link || '—' }}
            </p>
          </div>
 
          <div class="rounded-3xl bg-white p-4">
            <h2 class="text-md font-semibold text-[#073B4C]">Registration Deadline</h2>
            <p class="mt-2 leading-4 text-slate-600">
              {{ formatDate(conclave?.registration_deadline_date) || '—' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 